import script from "./CartView.vue?vue&type=script&setup=true&lang=js"
export * from "./CartView.vue?vue&type=script&setup=true&lang=js"

import "./CartView.vue?vue&type=style&index=0&id=4f121ae8&lang=scss"

const __exports__ = script;

export default __exports__